import { LoanRequest_NoteAdded } from 'cpool-events';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const NotesTableDefinitionZod = z.object({
    id: schemaId,
    notes: z.array(LoanRequest_NoteAdded.prototype.getSchema().merge(z.object({ timestamp: z.number() }))),
});

export type NotesTableSchema = z.infer<typeof NotesTableDefinitionZod>;
